<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" x-small text @click.stop="restoreAppointment"
        ><v-icon small>mdi-redo-variant</v-icon></v-btn
      >
    </template>
    <span> Restore </span>
    <confirm-modal ref="confirm"></confirm-modal>
  </v-tooltip>
</template>

<script>
import ConfirmModal from "../Shared/confirm-modal";

export default {
  components: {
    ConfirmModal,
  },
  props: ["appointmentId"],
  methods: {
    restoreAppointment: async function () {
      if (
        await this.$refs.confirm.open(
          "Are you sure you want to restore this appointment?",
          "",
          ""
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch(
          "appointmentsModule/restoreAppointment",
          this.appointmentId
        );
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
